import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import LocalStorageService from "../../utils/LocalStorageService";
import Constant, { url } from "../../utils/Constant";
import Loader from "../section/loader";
import UIkit from 'uikit';
import swal from "sweetalert";
import "../landing/etisalat-landing.css"
import Cookies from "js-cookie";
import {key, encrypt , decrypt } from "../../utils/encryptiondecryption";
import $, { error } from "jquery";



class EtisalatUae extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPackage: "5123", // Default radio option
      phoneNumber: "+971", // Default number input value
      hasError: "", //to check number is correct or not
      isDisabled: false, //if the form submit is in progress / api is taking time button is kept disabled
      otpisDisabled : false,
      resendOtpisDisabled : false , 
      packageList: [],
      isLoading: true,
      inputValue: "",
      iframe: "",
      isloaded: false,
      embededUrl: "",
      FormLoader : false ,
      loginmobilenumber: "",
      user_id : '' ,
      mobile : '' ,
      package_id : '' ,
      otp: ['', '', '', ''], // Assuming 4 OTP fields
      lang: "en" // Language state
    };
    this.inputRefs = [];
    this.handleSubmit = this.handleSubmit.bind(this);
    
    // Package prices mapping
    this.packagePrices = {
      "5123": "3.25", // Daily package price
      "5124": "11"    // Weekly package price
    };
  }
  
  // Language dictionary for English and Arabic with dynamic pricing
  getLangText = (key) => {
    const LANG = {
      en: {
        downloadApp: "Download App",
        freeTrial1: `1 day free trial then AED ${this.packagePrices[this.state.selectedPackage]}${this.state.selectedPackage === "5123" ? "/day" : "/week"}`,
        freeTrial2: "Watch Pakistani and international TV shows, movies, news, sports, and more",
        // freeTrial3: "30 days free trial then AED 111/month",
        pickMembership: "Pick a membership that fits you",
        packages: "Mjunoon Packages",
        enterNumber: "Enter your Etisalat number to receive an OTP",
        alreadyRegistered: "Already Registered ?",
        login: "Login",
        subscribeMe: "Subscribe Me!",
        exit: "Exit",
        otpVerification: "Enter the OTP received on mobile number to subscribe",
        resendOtp: "Resend OTP",
        subscribeText: "After clicking 'Subscribe' you will receive PIN message to Confirm your subscription.",
        terms: "Terms & Conditions",
        term1: "By Clicking on Subscribe, you agree to the below terms and conditions:",
        term2: "You will start the paid subscription after the free period automatically",
        term3: "No commitment, you can cancel your subscription at any time by sending C MJD To 1111 For Daily Plan Or Send C MJW To 1111 For Weekly",
        term4: "To get support, please contact ",
        term5: "The free trial is valid only for new subscribers",
        term6: "Enjoy your Free trial for 24 hours",
        term7: "Please make sure that your browser is not using any 3rd-party blocking technologies and you have a healthy internet connection for swift access to the content.",
        term8:  (
          <>
            Further Terms and conditions <a href="terms-and-conditions" className="custom-link">click here</a> & Privacy Policy <a href="privacy-policy" className="custom-link">click here</a>
          </>
        ),
        term9: "By proceeding, you are accepting all Terms and Conditions of the service and agree to receive updates about your subscription on your registered mobile number.",
      },
      ar: {
        downloadApp: "حمّل التطبيق",
        freeTrial1: `تجربة مجانية ليوم واحد ثم ${this.packagePrices[this.state.selectedPackage]} درهم${this.state.selectedPackage === "5123" ? "/يوم" : "/أسبوع"}`,
        freeTrial2: "شاهد المسلسلات والأفلام الباكستانية والعالمية، والأخبار، والرياضة، والمزيد",
        // freeTrial3: "تجربة مجانية لمدة 30 يومًا ثم 111 درهم/شهر",
        pickMembership: "Pick a membership that fits you",
        packages: "Mjunoon Packages",
        enterNumber: "أدخل رقم اتصالات الخاص بك لاستلام رمز التحقق",
        alreadyRegistered: "Already Registered ?",
        login: "Login",
        subscribeMe: "اشترك",
        exit: "خروج",
        otpVerification: "أدخل رمز OTP المرسل  لهاتفك المحمول  للاشتراك ",
        resendOtp: "إعادة إرسال رمز OTP",
        subscribeText: "بالضغط على 'اشترك'، سوف تتلقى رسالة تحتوي علي رمز PIN لتأكيد اشتراكك.",
        terms: "الشروط والأحكام",
        term1: "بالضغط على زر اشترك أعلاه، فأنت توافق على الشروط والأحكام التالية: ",
        term2: "سوف يبدأ الاشتراك المدفوع تلقائياً بعد فترة التجربة المجانية",
        term3: "بدون أي التزامات، يمكنك إلغاء اشتراكك في أي وقت عن طريق إرسال C MJD إلى 1111 للخطة اليومية، أو إرسال C MJW إلى 1111 للخطة الأسبوعية",
        term4: "للحصول على الدعم ، يرجى الاتصال علي  ",
        term5: "التجربة المجانية صالحة فقط للمشتركين لأول مرة",
        term6: "استمتع بفترة التجربة المجانية لمدة 24 ساعة",
        term7: "يرجى التأكد من عدم استخدام أي تقنيات حجب من الطرف الثالث على متصفحك والتأكد من وجود اتصال إنترنت جيد لضمان الوصول السريع للمحتوى.",
        term8: (
          <>
            للشروط والأحكام الإضافية <a href="terms-and-conditions" className="custom-link">اضغط هنا</a> وسياسة الخصوصية <a href="privacy-policy" className="custom-link">اضغط هنا</a>
          </>
        ),
        term9: "بالمتابعة، أنت توافق على جميع الشروط والأحكام الخاصة بالخدمة وتوافق على استلام تحديثات حول اشتراكك على رقم الجوال المسجل.",
      }
    };
    
    return LANG[this.state.lang][key];
  }

  componentDidMount() {
    localStorage.removeItem('temp_route')
    // this.getPackages();
    // this.getUserNumber();
    // this.checkUrl();
    // this.encryptedFunction();

    // this.callloginapi();


    setTimeout(() => {
      this.setState({ isLoading: false });
      var swiper = new window.Swiper(".banner-slider", {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 2,
        loop: true,
        coverflowEffect: {
          rotate: 0,
          scale: 1.15,
          stretch: 300,
          depth: 300,
          modifier: 1,
          slideShadows: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 2,
          },
        },
      });
    }, 2000);
  }

  // handleOtp = (e, index) => {
  //     const { value } = e.target;
  //     const newValue = value.match(/[0-9a-z]/gi) ? value[0] : '';

  //     this.setState(prevState => {
  //         const otp = [...prevState.otp];
  //         otp[index] = newValue;
  //         return { otp };
  //     }, () => {
  //         if (newValue && index < this.state.otp.length - 1) {
  //             this.inputRefs[index + 1].focus();
  //         }
  //         if (e.key === 'Backspace' && index > 0 && !newValue) {
  //             this.inputRefs[index - 1].focus();      
  //         }
  //     });
  // };

  handleOtp = (e, index) => {
    const { value } = e.target;
    const keyCode = e.keyCode || e.which;

    // console.log("KeyCode:", keyCode);

    if (keyCode == 8) {
        // Handle backspace key
        if (index > 0) {
            // Remove the OTP code from the current input field
            this.setState(prevState => {
                const otp = [...prevState.otp];
                otp[index] = ''; 
                return { otp };
            }, () => {
                // Move focus to the previous input
                this.inputRefs[index - 1].focus();
            });
        } else {
            // If index is already at 0, prevent further backspace action
            e.preventDefault();
        }
    } else {
        // Handle other keys
        const newValue = value.match(/[0-9a-z]/gi) ? value[0] : '';

        this.setState(prevState => {
            const otp = [...prevState.otp];
            otp[index] = newValue;
            return { otp };
        }, () => {
            if (newValue && index < this.state.otp.length - 1) {
                // Move focus to the next input
                this.inputRefs[index + 1].focus();
            }
        });
    }
};







  handleOnPasteOtp = (e) => {
      e.preventDefault();
      const data = e.clipboardData.getData('text');
      const value = data.split('');
      if (value.length === this.state.otp.length) {
          this.setState({ otp: value });
      }
  };

  handleOtpSubmit = () => {
    const otp = this.state.otp.join('');
    const otpInteger = parseInt(otp,10);

    
    this.setState({
      otpisDisabled : true
    })

    if(this.state.otp[3] === '' ){
      swal({
        icon : "error",
        text : "Invalid Otp"
      })
      this.setState({
        otpisDisabled : false
      })
      return
    }
    let params ={msisdn : this.state.phoneNumber , pincode : otpInteger , serviceId : this.state.selectedPackage } 
      axios({
        method: "POST",
        url: Constant.url + "verify-otp-ae",
        data: {
          dataparams : LocalStorageService.encryptAes(params)
        },

      }).then( (result)=> {
        if (result.status === 200) {
          let response = {};
          response["data"] = JSON.parse(
            LocalStorageService.decryptAes(result.data.eData)

          );

          if(response.data.code === 200){
              swal({
              icon: "Success",
              title: "Success",
              text: response.data.message,
            })
            setTimeout(() => {
              let params ={msisdn : this.state.phoneNumber}
              axios({
                method: "POST",
                url: Constant.url + "login-ae",
                data: {
                  dataparams : LocalStorageService.encryptAes(params)
                },

              }).then( (result)=> {
                // console.log(result)
                if (result.status === 200) {
                  let response = {};
                  response["data"] = JSON.parse(
                    LocalStorageService.decryptAes(result.data.eData)
                  );
                  
                  if(response.data.code === 200){
                      const message =  `device_id : ${response.data.data.device_id} ; 
                      phone_details : ${response.data.data.phone_details};
                      user_id : ${response.data.data.uid} ; 
                      mobile : ${response.data.data.mobile} ;
                      package_id : ${response.data.data.package_id};
                      subscription_expiry_datetime:  ${response.data.data.subscription_expiry_datetime};
                      next_package_id : ${response.data.data.next_package_id};`
                
                      this.dataStore(message)
                      window.location.href = "/"
                  }

                  else {
                    swal({
                      icon: "error",
                      title: "Error",
                      text: response.data.message,
                    })
                    
                  }
                }
                if (result.status === 400) {
                  // console.log("subscription api response failed");
                }
              });   
          } , 1000 )
          }
          else {
            swal({
              icon: "error",
              title: "Error",
              text: response.data.message,
            })
            this.setState({
              otpisDisabled : false
            })
          }
        }

        if (result.status === 400) {
          // console.log("subscription api response failed");
        }
      });
  };

  handleRadioChange = (event) => {
    this.setState({
      selectedPackage: event.target.value,
    });

  };

  handleNumberChange = (event) => {
    const inputPhoneNumber = event.target.value;
    this.setState({ phoneNumber: event.target.value });
  };




  handleSubmit2 = (event) => {
    event.preventDefault();


    this.setState({
      FormLoader : true
    })
    let classRef = this;

    
    let phone = this.state.phoneNumber

    function isValidUAEPhoneNumber(phoneNumber) {
      const phoneRegex = /^971\d{1,9}$/;
      return phoneRegex.test(phoneNumber);
    }


    function removePlusFromPhoneNumber(phoneNumber) {
      return phoneNumber.startsWith('+') ? phoneNumber.substring(1) : phoneNumber;
    }

    phone = removePlusFromPhoneNumber(this.state.phoneNumber)

    if (isValidUAEPhoneNumber(phone)) {
      classRef.setState({
        phoneNumber: phone,
        hasError: "",
      });


      let params ={msisdn : phone }
      axios({
        method: "POST",
        url: Constant.url + "login-ae",
        data: {
          dataparams : LocalStorageService.encryptAes(params)
        },

      }).then( (result)=> {
        // console.log(result)
        if (result.status === 200) {
          let response = {};
          response["data"] = JSON.parse(
            LocalStorageService.decryptAes(result.data.eData)
          );

          if(response.data.code === 200){
            swal({
              icon: "success",
              title: "Login Successful",
            }).then( () => {

              const message =  `device_id : ${response.data.data.device_id} ; 
              phone_details : ${response.data.data.phone_details};
              user_id : ${response.data.data.uid} ; 
              mobile : ${response.data.data.mobile} ;
              package_id : ${response.data.data.package_id};
              subscription_expiry_datetime:  ${response.data.data.subscription_expiry_datetime};
              next_package_id : ${response.data.data.next_package_id};`
        
              this.dataStore(message)

              setTimeout( () => {
              window.location.href = "/"
              } , 2000 )
            } )
          }
          
          else {
            swal({
              icon: "error",
              title: "Error",
              text: response.data.message,
            })
            this.setState({
              FormLoader : false
            })
          }
        }
        if (result.status === 400) {
          // console.log("subscription api response failed");
        }
      });
    } 
    
    else {
      this.setState({
        FormLoader : false
      })
      swal({
        icon : "warning" ,
        text : "Invalid Phone Number"
      }).then(() => {
        // document.getElementsByClassName('.uae-mobile-form').reset();
      })
    }
  };

  resendotp = () => {

    this.setState({
      resendOtpisDisabled:true
    })
    let params ={msisdn : this.state.phoneNumber , serviceId : this.state.selectedPackage}
    axios({
      method: "POST",
      url: Constant.url + "send-otp-ae",
      data: {
        dataparams : LocalStorageService.encryptAes(params)
      },

    }).then( (result)=> {
      if (result.status === 200) {
        let response = {};
        response["data"] = JSON.parse(
          LocalStorageService.decryptAes(result.data.eData)
        );


        if(response.data.code === 200){
         
          swal({
            icon: "success",
            title: "Otp Resent Succesfully",
          })
          this.setState({
            resendOtpisDisabled:false
          })
        }
        else{
          swal({
            icon: "error",
            title: response.data.message,
          })
          this.setState({
            resendOtpisDisabled:false
          })
        }
        
      }
    }); 
  
  }



  handleSubmit = (event) => {
    event.preventDefault();
    // console.log(this.state.selectedPackage)
    let classRef = this;
  
    let phone = event.target.phoneBn.value;

    classRef.setState({
      isDisabled : true
    })
    function isValidUAEPhoneNumber(phoneNumber) {
      const phoneRegex = /^971\d{1,9}$/;
      return phoneRegex.test(phoneNumber);
    }
    function removePlusFromPhoneNumber(phoneNumber) {
      return phoneNumber.startsWith('+') ? phoneNumber.substring(1) : phoneNumber;
    }

    phone = removePlusFromPhoneNumber(this.state.phoneNumber)

    if (isValidUAEPhoneNumber(phone)) {
      classRef.setState({
        phoneNumber: phone,
        hasError: "",
      });

      let params ={msisdn : phone , serviceId : this.state.selectedPackage}

      axios({
        method: "POST",
        url: Constant.url + "send-otp-ae",
        data: {
          dataparams : LocalStorageService.encryptAes(params)
        },

      }).then( (result)=> {
        
        if (result.status === 200) {
          let response = {};
          response["data"] = JSON.parse(
            LocalStorageService.decryptAes(result.data.eData)
          );

          // console.log("submit on maoin response: ", response.data);

          if(response.data.code === 200){
            $(".uae-phone-container").fadeOut(500); // Fade out over 1 second 
            $(".otp-container").fadeIn(2000);
              swal({
                icon: "success",
                title: response.data.message,
              }).then(() => {

                
                  // Fade out over 1 second 
              })
          }
          
          else if(response.data.code === 222){
            swal({
              icon: "success",
              title: response.data.message,
            }).then(() => {
            })
            const message =  `device_id : ${response.data.data.device_id} ; 
            phone_details : ${response.data.data.phone_details};
            user_id : ${response.data.data.uid} ; 
            mobile : ${response.data.data.mobile} ;
            package_id : ${response.data.data.package_id};
            subscription_expiry_datetime:  ${response.data.data.subscription_expiry_datetime};
            next_package_id : ${response.data.data.next_package_id};`
            
              const encryptedText = encrypt(message, key);
              Cookies.set(
              "YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD",
              encryptedText,
              {
                expires: 1 // 1 day expiry 
              }
            );   
            
            
            setTimeout(() => {
              window.location.href = "/"; // Replace "/home" with the actual URL of your home page
            }, 2000); // 3000 milliseconds = 3 seconds
          
          }

          else {
            classRef.setState({
              isDisabled : false
            })
            swal({
              icon: "error",
              title: "Error",
              text: response.data.message,
            })
          }
        }
        else{
          swal({
            icon: "error",
            title: "Error Occured",
            text: 'Try Again Later',
          })
        }
        
      });
    } 
    
    else {
      classRef.setState({
        isDisabled : false
      })
      swal({
        icon : "warning" ,
        text : "Invalid Phone Number"
      }).then(() => {
        // document.getElementsByClassName('.uae-mobile-form').reset();      
      })
    }
  };



  dataStore = (message) => {
    const encryptedText = encrypt(message, key);
    Cookies.set(
      "YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD",
      encryptedText,
      {
        expires: 1,
      }
    );
  };

  
  //function for login from login form of Already Registered 
 

  // getUserNumber = () => {
  //   let classRef = this;
  //   axios({
  //     method: "GET",
  //     url: "http://ibadat.co/digi.msisdn.get.app",
  //   })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         const responseData = response.data; // Assuming 'data' key contains the API response data

  //         if (responseData === "could not track") {
  //           console.log("Umair responseData", responseData);
  //           this.setState({ phoneNumber: "" });
  //         } else if (/^8801[3-7][0-9]{8}$/.test(responseData)) {
  //           this.setState({ phoneNumber: responseData });
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // };

  signinform = () => {
    UIkit.modal("#modal-login").show();
  };



  setmobilenumber = (e) => {
    this.setState({ phoneNumber: e.target.value });
  };

  handleExit = (e) => {
    e.preventDefault()
    localStorage.setItem("temp_route" , 10)
    window.location.href = "/"
  }



  render() {
    return this.state.isLoading ? (
      <Loader />
    ) : (
      <>
        {/* modals */}
        <div id="modal-iframe" uk-modal="true">
          <div className="uk-modal-dialog uk-modal-body">
            <button
              className="uk-modal-close-default"
              type="button"
              uk-close="true"
            ></button>
            <iframe
              src={this.state.embededUrl}
              title="Embedded Website"
              width="100%"
              height="500px"
            ></iframe>
          </div>
        </div>
        <div id="modal-login" uk-modal="true">
          <div
            className="uk-modal-dialog uk-modal-body"
            style={{ backgroundColor: "#0e0c0c", width: "430px" }}
          >
            <button
              className="uk-modal-close-default"
              type="button"
              uk-close="true"
            ></button>
            <div className="loginform">
              {" "}
              <form onSubmit={this.handleSubmit2} style={{ height: "400px" }}>
                <img src="images/logo192.png" />
                <h1 style={{ color: "#B066FE", fontWeight: "600" }}>
                  {this.getLangText('login')}
                </h1>{" "}
                <input
                  style={{
                    width: "73%",
                    background: "#0c0a0a",
                    color: "white",
                  }}
                  value={this.state.phoneNumber}
                  onChange={this.setmobilenumber}
                  placeholder="mobile number....."
                  className="uk-input"
                  type="number"
                ></input>
                <button
                  className="uk-button loginbtn "
                  type="submit"
                  style={{ marginTop: "20px", backgroundColor: "#B066FE" }}
                >
                  {this.getLangText('login')}
                </button>
                {this.state.FormLoader ? (
                  <img
                    className="loader-form mx-auto"
                    src="/images/landing/giphy.gif"
                    width={"20px"}
                    height={"20px"}
                    style={{ marginTop: "20px", display: "block" }}
                  />
                ) : (
                  ""
                )}
              </form>
            </div>
          </div>
        </div>
        {/*  */}
        <header className="landing-header">
          <div className="container">
            <div>
              <Link to="/">
                {" "}
                <img
                  className="img-logo"
                  src="/images/logo.webp"
                  alt="mJunoon.tv"
                />
              </Link>
            </div>
            <div className="mobileList">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <span className="download">Download App</span>
                </li>
                <li className="list-inline-item">
                  <a href="https://appgallery.huawei.com/#/app/C100874529">
                    <img
                      className="img-store-icons"
                      src="/images/Badge-Black@3x.png"
                      alt="Mjunoon Huawei App"
                    />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://play.google.com/store/apps/details?id=com.convex.mjunoon.TV&amp;hl=en">
                    <img
                      className="img-store-icons"
                      src="/images/googleplay.png"
                      alt="Mjunoon Huawei App"
                    />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="https://itunes.apple.com/us/app/mjunoon-tv/id1107354784?mt=8">
                    <img
                      className="img-store-icons"
                      src="/images/apstore.png"
                      alt="Mjunoon IOS App"
                    />
                  </a>
                </li>
                {/* onClick={() => this.setState({ lang: this.state.lang === "en" ? "ar" : "en" })} */}

                <li className="list-inline-item">
                  <button className="language-btn" onClick={() => this.setState({ lang: this.state.lang === "en" ? "ar" : "en" })}>
                    {this.state.lang === "en" ? "العربية" : "English"}
                  </button>
                </li>
              </ul>
              
            </div>
            {/* Language toggle button */}
            
          </div>
        </header>
        <div className="discount-banner" dir={this.state.lang === "ar" ? "rtl" : "ltr"}>
                <ul className="uk-list"> 
                  <li><h4>{this.getLangText('freeTrial1')}</h4></li>
                  <li><h4>{this.getLangText('freeTrial2')}</h4></li>
                  <li><h4>{this.getLangText('freeTrial3')}</h4></li>
                </ul>
        </div>

        <main>
          <section className="uae-banner-landing">
            <div className="container">
              <div className="mx-auto">
                <h1>{this.getLangText('pickMembership')}</h1> 
                <div className="uae-form-container" id="uae-form-container">
                  <h3 className="text-center">
                    <img src="/images/landing/uae/m-icon.png" /> {this.getLangText('packages')}
                  </h3>
                  <form
                    ref={(form) => (this.myForm = form)}
                    onSubmit={this.handleSubmit}
                    encType="multipart/form-data"
                    className="uae-mobile-form"
                  >
                    <div className="package-list-container">
                      <ul className="package-list">
                        <li>
                          <label htmlFor="daily">
                            <span>
                              <input
                                type="radio"
                                onChange={this.handleRadioChange}
                                value="5123"
                                id="daily"
                                name="uae_packages"
                                checked={this.state.selectedPackage === "5123"}
                              />{" "}
                              Daily Package
                            </span>
                            <span className="span-price">AED {this.packagePrices["5123"]}/day</span>
                          </label>
                        </li>
                        <li>
                          <label htmlFor="weekly">
                            <span>
                              <input
                                type="radio"
                                onChange={this.handleRadioChange}
                                value="5124"
                                id="weekly"
                                name="uae_packages"
                              />{" "}
                              Weekly Package
                            </span>
                            <span className="span-price">AED {this.packagePrices["5124"]}/week</span>
                          </label>
                        </li>
                      </ul>
                    </div>

                    <div className="uae-phone-container">
                      <p>{this.getLangText('enterNumber')}</p>
                      <input
                        id="phoneBn"
                        name="phoneBn"
                        type="text"
                        required=""
                        pattern="\971\d{1,9}$"
                        title="Enter a valid UAE phone number"
                        placeholder="+971 5xxxxxxxx"
                        onChange={this.handleNumberChange}
                        value={this.state.phoneNumber}
                      />
                      {this.state.hasError ? (
                        <span className="val-errors">Form error</span>
                      ) : (
                        ""
                      )}
                      {this.state.isDisabled ? (
                        <img
                          className="loader-form mx-auto"
                          src="/images/landing/giphy.gif"
                          width={"20px"}
                          height={"20px"}
                          style={{ marginTop: "20px", display: "block" }}
                        />
                      ) : (
                        <>
                        <div className=" form-btns uk-flex">
                          <button
                            className="form-submit loginbtn"
                            type="submit"
                            // disabled={this.state.isDisabled}
                          >
                            {this.getLangText('subscribeMe')}
                          </button>
                          <button onClick={this.handleExit}  className="  loginbtn ">
                        {this.getLangText('exit')}
                      </button>
                      </div>
                        </>
                      )}

                      <h6  dir={this.state.lang === "ar" ? "rtl" : "ltr"} style={{ marginTop: "10px" }} className="uk-text-center uk-light">{this.getLangText('subscribeText')}</h6>
                      <p>
                        {this.getLangText('alreadyRegistered')} {" "}
                        <a onClick={this.signinform}> {this.getLangText('login')} </a>{" "}
                      </p>
                    </div>
                  </form>
                  {/* otp fields */}
                  <div className="otp-container" dir={this.state.lang === "ar" ? "rtl" : "ltr"} style={{ display: "none" }}>
                    <p>{this.getLangText('otpVerification')}</p>
                    <div className="otp-field">
                      {this.state.otp.map((value, index) => (
                        <input
                          key={index}
                          ref={(input) => (this.inputRefs[index] = input)}
                          type="text"
                          maxLength="1"
                          value={value}
                          onChange={(e) => this.handleOtp(e, index)}
                          onKeyDown={(e) => this.handleOtp(e, index)}
                          onPaste={this.handleOnPasteOtp}
                          // disabled={value !== ''}
                          className={value !== "" ? "disabled" : ""}
                        />
                      ))}
                    </div>

                    {this.state.otpisDisabled ? (
                      <img
                        className="loader-form mx-auto"
                        src="/images/landing/giphy.gif"
                        width={"20px"}
                        height={"20px"}
                        style={{ marginTop: "12px", display: "block" }}
                      />
                    ) : (
                      <button onClick={this.handleOtpSubmit}>{this.getLangText('subscribeMe')}</button>
                    )}

                    {this.state.resendOtpisDisabled ? (
                      <img
                        className="loader-form mx-auto"
                        src="/images/landing/giphy.gif"
                        width={"20px"}
                        height={"20px"}
                        style={{ marginTop: "12px", display: "block" }}
                      />
                    ) : (
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={this.resendotp}
                        className="resend-otp"
                      >
                        {this.getLangText('resendOtp')}
                      </span>
                    )}
                  </div>
                  {/* otp fields ends*/}
                </div>
              </div>
            </div>
          </section>
          <section className="terms-section">
            <div className="container" dir={this.state.lang === "ar" ? "rtl" : "ltr"}>
              <h2>{this.getLangText('terms')}</h2>
              <ul>
              <li>{this.getLangText('term1')}</li>
            <li>{this.getLangText('term2')}</li>
            <li>{this.getLangText('term3')}</li>
            <li>{this.getLangText('term4')} <a href="mailto:info@mjunoon.tv">info@mjunoon.tv</a></li>
            <li>{this.getLangText('term5')}</li>
            <li>{this.getLangText('term6')}</li>
              <li>{this.getLangText('term7')}</li>
              <li>{this.getLangText('term8')}</li>
              <li>{this.getLangText('term9')}</li>
            </ul>
            </div>
          </section>
        </main>
        <footer className="pad_right pad_left pad_tb">
          <div className="uk-height-match uk-grid uk-grid-stack" uk-grid="">
            <div className="uk-width-1-2@l uk-width-1-1@m uk-width-1-1@s uk-first-column">
              <ul>
                <li>
                  <a href="/about-us">ABOUT US</a>
                </li>
                <li>
                  <a href="/privacy-policy">PRIVACY POLICY</a>
                </li>
                <li>
                  <a href="/terms-and-conditions">TERMS &amp; CONDITIONS</a>
                </li>
                <li>
                  <a href="/contact-us">CONTACT US</a>
                </li>
                <li>
                  <a href="/faqs">FAQS</a>
                </li>
              </ul>
              <p>
                All Rights Reserved. &copy; Copyright 2017 - 2024 mjunoon.tv |
                Powered by{" "}
                <a href="https://www.convexinteractive.com/" target="_blank">
                  Convex Interactive PVT LTD.
                </a>
              </p>
            </div>
            <div className="uk-width-1-2@l uk-width-1-1@m uk-width-1-1@s uk-grid-margin uk-first-column">
              <div className="ftr_btns">
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.convex.mjunoon.TV&amp;hl=en"
                >
                  <img
                    src="../../images/googleplay.png"
                    alt="Mjunoon Androiod App"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://itunes.apple.com/us/app/mjunoon-tv/id1107354784?mt=8"
                >
                  <img src="../../images/apstore.png" alt="Mjunoon IOS App" />
                </a>
                <a
                  target="_blank"
                  href="https://appgallery.huawei.com/#/app/C100874529"
                >
                  <img
                    src="/images/Badge-Black@3x.png"
                    alt="Mjunoon Huawei App"
                  />
                </a>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default EtisalatUae;
